import { Button } from '@shared/components/common/Button';
import { Checkbox } from '@shared/components/common/Checkbox';
import { Form, FormControl, FormField, FormItem, FormLabel } from '@shared/components/common/Form';
import { STEP_ONE } from '@shared/components/constants/common.constants';
import { ROUTES } from '@shared/configs/constants';
import yup from '@shared/services/yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';

export default function ConfirmTerm() {
    // hook
    const navigate = useNavigate();
    // form
    const validateSchema = yup.object().shape({
        term_of_use: yup.boolean().oneOf([true]).required(),
        privacy_policy: yup
            .boolean()
            .oneOf([true])
            .required()
    });

    type FormData = yup.InferType<typeof validateSchema>;

    const form = useForm<FormData>({
        resolver: yupResolver(validateSchema),
        mode: 'onChange',
        defaultValues: {
        }
    });

    const onSubmit = (data) => {
        const { term_of_use, privacy_policy } = data;

        if (term_of_use && privacy_policy) {
            navigate(ROUTES.registrationStepOne.href + '?sub=' + STEP_ONE.INPUT_EMAIL);
        }
    };

    return (
        <div className='flex flex-col gap-8 w-full'>
            <h2 className='text-center text-cs-sub-title text-[#121212]'>ご登録前の確認事項</h2>
            <Form {...form}>
                <form onSubmit={form.handleSubmit(onSubmit)} className='flex flex-col gap-8'>
                    <div className='bg-background-1 flex flex-col md:gap-6 gap-4 rounded-[4px]'>
                        <FormField
                            control={form.control}
                            name='term_of_use'
                            render={({ field }) => (
                                <FormItem className='flex items-center gap-3'>
                                    <FormControl>
                                        <Checkbox
                                            className='size-5 bg-white'
                                            checked={field.value}
                                            onCheckedChange={checked => field.onChange(checked)}
                                        >
                                        </Checkbox>
                                    </FormControl>
                                    <FormLabel className='!mt-0 text-cs-label leading-[25px]'>
                                        <Link
                                            className='text-link-1 underline text-[#009ACD]'
                                            target='_blank'
                                            // to='https://elephamt.jp/term-of-service'
                                            to={ROUTES.termsOfService.href}
                                        >
                                            利用規約
                                        </Link>
                                        に同意する
                                    </FormLabel>
                                </FormItem>
                            )}
                        />
                        <FormField
                            control={form.control}
                            name='privacy_policy'
                            render={({ field }) => (
                                <FormItem className='flex items-center gap-3'>
                                    <FormControl>
                                        <Checkbox
                                            className='size-5 bg-white'
                                            checked={field.value}
                                            onCheckedChange={checked => field.onChange(checked)}
                                        >
                                        </Checkbox>
                                    </FormControl>
                                    <FormLabel className='!mt-0 text-cs-label leading-[25px]'>
                                        <Link
                                            className='text-link-1 underline text-[#009ACD]'
                                            target='_blank'
                                            // to='https://elephamt.jp/privacy-policy'
                                            to={ROUTES.privacyPolicy.href}
                                        >
                                            個人情報保護方針
                                        </Link>
                                        を確認した
                                    </FormLabel>
                                </FormItem>
                            )}
                        />
                        <p className='text-red-1 font-medium text-cs-label text-[#D42A1C]'>上記の内容を必ずご確認の上、チェックを入れてください。</p>
                    </div>
                    <div className='flex justify-center w-full'>
                        <Button
                            variant='default'
                            className='rounded-[10px] w-full h-[56px] text-cs-button text-[#ffffff]'
                            disabled={!form.formState.isValid}
                        >
                            次へ
                        </Button>
                    </div>
                </form>
            </Form>
        </div>
    );
}
